/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckPaxSession } from './PaxCheckPaxSession';
import {
    PaxCheckPaxSessionFromJSON,
    PaxCheckPaxSessionFromJSONTyped,
    PaxCheckPaxSessionToJSON,
    PaxCheckPaxSessionToJSONTyped,
} from './PaxCheckPaxSession';

/**
 * 
 * @export
 * @interface PaxCheckApplyRecognisedDocumentResult
 */
export interface PaxCheckApplyRecognisedDocumentResult {
    /**
     * 
     * @type {PaxCheckPaxSession}
     * @memberof PaxCheckApplyRecognisedDocumentResult
     */
    updatedPaxSession: PaxCheckPaxSession;
    /**
     * 
     * @type {Array<PaxCheckPaxSession>}
     * @memberof PaxCheckApplyRecognisedDocumentResult
     */
    additionalPaxSessions?: Array<PaxCheckPaxSession> | null;
}

/**
 * Check if a given object implements the PaxCheckApplyRecognisedDocumentResult interface.
 */
export function instanceOfPaxCheckApplyRecognisedDocumentResult(value: object): value is PaxCheckApplyRecognisedDocumentResult {
    if (!('updatedPaxSession' in value) || value['updatedPaxSession'] === undefined) return false;
    return true;
}

export function PaxCheckApplyRecognisedDocumentResultFromJSON(json: any): PaxCheckApplyRecognisedDocumentResult {
    return PaxCheckApplyRecognisedDocumentResultFromJSONTyped(json, false);
}

export function PaxCheckApplyRecognisedDocumentResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckApplyRecognisedDocumentResult {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedPaxSession': PaxCheckPaxSessionFromJSON(json['updated_pax_session']),
        'additionalPaxSessions': json['additional_pax_sessions'] == null ? undefined : ((json['additional_pax_sessions'] as Array<any>).map(PaxCheckPaxSessionFromJSON)),
    };
}

export function PaxCheckApplyRecognisedDocumentResultToJSON(json: any): PaxCheckApplyRecognisedDocumentResult {
    return PaxCheckApplyRecognisedDocumentResultToJSONTyped(json, false);
}

export function PaxCheckApplyRecognisedDocumentResultToJSONTyped(value?: PaxCheckApplyRecognisedDocumentResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updated_pax_session': PaxCheckPaxSessionToJSON(value['updatedPaxSession']),
        'additional_pax_sessions': value['additionalPaxSessions'] == null ? undefined : ((value['additionalPaxSessions'] as Array<any>).map(PaxCheckPaxSessionToJSON)),
    };
}

